const cities = [
  "Panama City",
  "Lynn Haven",
  "Callaway",
  "Parker",
  "Springfield",
  "Panama City Beach",
  "Mexico Beach",
  "Cedar Grove",
  "Hiland Park",
  "Southport",
];

export default function ServiceAreaBanner() {
  const row = [...cities, ...cities];
  return (
    <section id="area" className="bg-[#334155] text-white py-20 sm:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#0EA5E9]">Service Area</div>
            <h2 className="mt-3 font-heading font-black uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Proudly Serving<br />All Of <span className="text-[#0EA5E9]">Bay County, FL.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base sm:text-lg text-[#CBD5E1] leading-relaxed">
              From the bay to the beaches, we cover every corner of Bay County.
              <span className="block mt-3 text-white font-semibold">
                Note: We do not service Tyndall Air Force Base.
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="mt-14 border-y-2 border-white/10 py-6">
        <div className="marquee-track flex gap-12 whitespace-nowrap">
          {row.map((c, i) => (
            <span
              key={`${c}-${i}`}
              className="font-heading font-black uppercase tracking-tight text-3xl sm:text-5xl text-white/90"
            >
              {c}
              <span className="mx-12 text-[#0EA5E9]">/</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
